export default __webpack_public_path__ + "static/media/evrfy_top-01.49e6347f.svg";